module.exports = __webpack_public_path__ + "static/media/icon-download-white.20170d08.svg";